import { Grid, Paper } from "@material-ui/core";
import React from "react";

import TextEdit from "../../../../../components/wysiwyg/TextEdit";
import IEventFull from "../../../../../types/IEventFull";

type IEventReportTab = {
    eventData: IEventFull;
    onWysiwygChange: (editorState: any, name: string) => void;
};

const EventReportTab = (props: IEventReportTab) => {
    const { eventData, onWysiwygChange } = props;

    return (
        <Paper variant="outlined" className={"main-paper"}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <TextEdit
                        handleChange={(event: any) => {
                            onWysiwygChange(event, "descriptionAfter");
                        }}
                        title="Veranstaltungsbericht Links"
                        defaultValue={eventData.descriptionAfter || " "}
                    />
                </Grid>{" "}
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <TextEdit
                        handleChange={(event: any) => {
                            onWysiwygChange(event, "descriptionAfter2");
                        }}
                        title="Veranstaltungsbericht Rechts"
                        defaultValue={eventData.descriptionAfter2 || " "}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

export default EventReportTab;
